import { render, staticRenderFns } from "./ExhibitionIntroduction.vue?vue&type=template&id=5c45721e&"
import script from "./ExhibitionIntroduction.vue?vue&type=script&lang=js&"
export * from "./ExhibitionIntroduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports